///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { SuiTypeString } from '@siklu/sui-lib/infrastructure';
import { SuiManagedUserVM } from '../generated/shared-sui-types.model';
import { ManagedUserVM } from '../generated/shared-types.model';
import { validatorFn } from '@siklu/sui-lib/infrastructure/abstract/validator-type';

// `createPasswordField()` are initialised as instances of SuiManagedUserVM for unified password validation management.
// Using these objects ensures that any changes in validation rules (min/max length, regex patterns)
// will be automatically applied to all relevant components.
export function createPasswordFieldsPair(): [SuiTypeString, SuiTypeString] {
    const passwordField = new SuiManagedUserVM({} as ManagedUserVM).password;
    const confirmPasswordField = new SuiManagedUserVM({} as ManagedUserVM).password;

    passwordField.isMandatory = true;
    passwordField.valueChangedCallback = () => {
        confirmPasswordField.validateAndShowError();
    };

    confirmPasswordField.isMandatory = true;
    const validator: validatorFn = () => {
        const message = 'The password and its confirmation do not match!';
        const isNotValid = confirmPasswordField.value !== passwordField.value;
        return {
            isEnabled: isNotValid,
            isActivated: isNotValid,
            translationPath: isNotValid ? message : null
        };
    };

    confirmPasswordField.validators.push(validator);

    return [passwordField, confirmPasswordField];
}
